import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { Tabs } from "antd";
import Overview from "./Overview";
import Details from "./Detail";
import Compare from "./Compare";
import { getDataNatcomAirtime } from "../../../../redux/Future/Natcom/action";

export default function MissCall() {
  const dispatch = useDispatch();
  const [tabActive, setTabActive] = useState("1");

  const handleGetDataError = (startDate, endDate) => {
    const url = `/api/get-data-sub-error-airtime-natcom?startDate=${startDate}&endDate=${endDate}`;
    dispatch(getDataNatcomAirtime(url));
  }

  const items = [
    {
      key: "1",
      label: "Overview",
      children: (
        <Overview handleGetData={handleGetDataError} tabActive={tabActive} />
      ),
    },
    {
      key: "2",
      label: "Details",
      children: <Details handleGetData={handleGetDataError} tabActive={tabActive} />,
    },
    {
      key: "3",
      label: "Compare",
      children: <Compare handleGetData={handleGetDataError} tabActive={tabActive} />,
    },
  ];

  const onChangeTabs = (key) => {
    setTabActive(key);
  };

  return (
    <Container>
      <Breadcrumbs data={["Natcom", "Vmail", "Miss Call"]} />
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-tabs-tab {
    font-size: 15px;
    padding: 5px 20px;
  }
`;